// This is generated.  Alter it in blockGroups/formElements/types/InvisibleElement.js
/* eslint-disable no-unused-vars */
const { Type } = require('@sinclair/typebox');
const { merge } = require('lodash');
const { config, moduleRegistration } = require('@sstdev/lib_metadata-config');
module.exports = {
  asDataDictionary: function asDataDictionary(hNode, context) {
    const {
      id,
      title,
      propertyName,
      dataType,
      overrideDataType,
      format,
      overrideDataFormat,
      required,
      defaultValue,
    } = hNode;

    const subDataDictionary = {};

    // Process nested invisible elements if present
    let nestedProperties = {};
    if (hNode.children) {
      const [_subDataDictionary = {}, _partialTypeDefinition = {}] =
        hNode.children.reduce(
          ([sdd, ptd], child) => {
            const [childSubDict = {}, childPartial = {}] =
              context.extractFromChild(child, context);
            return [
              merge(sdd, childSubDict),
              moduleRegistration.mergePartialTypeDefinitions(
                ptd,
                childPartial,
                context,
              ),
            ];
          },
          [{}, {}],
        );
      nestedProperties = _partialTypeDefinition;
    }

    // reuse consistent flags
    const { isOptional, schemaOptions } = moduleRegistration.resolveFieldFlags(
      required,
      context,
    );

    // Determine the actual data type and format to use
    const actualDataType = overrideDataType || dataType || 'string';
    const actualFormat = overrideDataFormat || format;

    // Build the base options for all schema types
    const baseOptions = {
      title: title,
      'x-id': id,
      'x-dataType': actualDataType,
      'x-propertyName': propertyName,
      ...schemaOptions,
    };

    // Add format if present (standard formats use 'format', custom use 'x-format')
    // Standard JSON Schema 2020-12 formats: email, date-time, date, time, uri, etc.
    if (actualFormat) {
      const standardFormats = [
        'date-time',
        'date',
        'time',
        'duration',
        'email',
        'idn-email',
        'hostname',
        'idn-hostname',
        'ipv4',
        'ipv6',
        'uri',
        'uri-reference',
        'iri',
        'iri-reference',
        'uri-template',
        'json-pointer',
        'relative-json-pointer',
        'regex',
      ];

      if (standardFormats.includes(actualFormat)) {
        baseOptions.format = actualFormat;
      } else {
        baseOptions['x-format'] = actualFormat;
      }
    }

    // Add default value if present and valid for the data type
    // Empty strings are not valid defaults for non-string types
    if (
      defaultValue !== undefined &&
      defaultValue !== null &&
      defaultValue !== ''
    ) {
      // Convert default value to appropriate type if needed
      const normalizedDataType = actualDataType.toLowerCase();
      let typedDefault = defaultValue;

      if (normalizedDataType === 'bool' || normalizedDataType === 'boolean') {
        // Convert string booleans to actual booleans
        if (typeof defaultValue === 'string') {
          typedDefault = defaultValue.toLowerCase() === 'true';
        }
      } else if (
        normalizedDataType === 'number' ||
        normalizedDataType === 'float' ||
        normalizedDataType === 'double'
      ) {
        typedDefault = parseFloat(defaultValue);
        if (isNaN(typedDefault)) typedDefault = undefined;
      } else if (
        normalizedDataType === 'integer' ||
        normalizedDataType === 'int'
      ) {
        typedDefault = parseInt(defaultValue, 10);
        if (isNaN(typedDefault)) typedDefault = undefined;
      }
      // For arrays and other complex types, don't set a string default
      else if (
        normalizedDataType === 'array' ||
        normalizedDataType === 'object'
      ) {
        typedDefault = undefined;
      }

      if (typedDefault !== undefined) {
        baseOptions.default = typedDefault;
      }
    }

    // Helper to wrap schema as optional if needed
    const maybeOptional = (schema) =>
      isOptional ? Type.Optional(schema) : schema;

    // Create the appropriate TypeBox schema based on data type
    let schema;
    const hasNestedElements = Object.keys(nestedProperties).length > 0;

    if (hasNestedElements) {
      // Build the object schema for the nested properties
      const objectSchema = Type.Object(nestedProperties, {
        ...baseOptions,
        additionalProperties: true,
      });

      // Check if this should be an array of objects
      if (actualDataType.toLowerCase() === 'array') {
        schema = Type.Array(objectSchema, baseOptions);
      } else {
        schema = objectSchema;
      }
    } else {
      // Create schema based on data type
      switch (actualDataType.toLowerCase()) {
        case 'array':
          schema = maybeOptional(
            Type.Array(
              Type.Object(
                {},
                {
                  title: 'Item',
                  'x-dataType': 'object',
                  additionalProperties: true,
                },
              ),
              baseOptions,
            ),
          );
          break;
        case 'bool':
        case 'boolean':
          schema = maybeOptional(Type.Boolean(baseOptions));
          break;
        case 'number':
        case 'float':
        case 'double':
          schema = maybeOptional(Type.Number(baseOptions));
          break;
        case 'integer':
        case 'int':
          schema = maybeOptional(Type.Integer(baseOptions));
          break;
        case 'string':
        default:
          schema = maybeOptional(Type.String(baseOptions));
          break;
      }
    }

    // If not using maybeOptional above (for objects), wrap here
    if (hasNestedElements && isOptional) {
      schema = Type.Optional(schema);
    }

    const partialTypeDefinition = {
      [propertyName]: schema,
    };

    return [subDataDictionary, partialTypeDefinition];
  },
};
moduleRegistration.registerHNodeType(
  'formElements',
  'InvisibleElement',
  module.exports,
);
